"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Required = exports.computeBorderColor = exports.Input = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _Box = require("../Box");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Input component
 */
var Input = _react.default.forwardRef(function (_ref, ref) {
  var description = _ref.description,
      disabled = _ref.disabled,
      error = _ref.error,
      required = _ref.required,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["description", "disabled", "error", "required", "title"]);

  return _react.default.createElement(_Box.Box, {
    width: "100%"
  }, title && _react.default.createElement(_Typography.Sans, {
    mb: "0.5",
    size: "3"
  }, title, required && _react.default.createElement(Required, null, "*")), description && _react.default.createElement(_Typography.Sans, {
    color: "black60",
    mb: "1",
    size: "2"
  }, description), _react.default.createElement(StyledInput, _extends({
    ref: ref,
    disabled: disabled,
    error: !!error
  }, rest)), error && _react.default.createElement(_Typography.Sans, {
    color: "red100",
    mt: "1",
    size: "2"
  }, error));
});

exports.Input = Input;

/**
 * func to compute border color
 */
var computeBorderColor = function computeBorderColor(inputStatus) {
  var disabled = inputStatus.disabled,
      error = inputStatus.error,
      pseudo = inputStatus.pseudo;
  if (disabled) return "black10";
  if (error) return "red100";
  if (pseudo === "hover") return "black60";
  if (pseudo === "focus") return "purple100";
  return "black10";
};

exports.computeBorderColor = computeBorderColor;

var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "bysdh7-0"
})(["font-family:", ";font-size:", "px;line-height:", "px;height:40px;background-color:", ";border:1px solid ", ";border-radius:0;transition:border-color 0.25s;padding:", "px;width:100%;&:hover{border-color:", ";}&:focus{border-color:", ";}"], (0, _styledSystem.themeGet)("fontFamily.sans.regular"), (0, _styledSystem.themeGet)("typeSizes.sans.3.fontSize"), (0, _styledSystem.themeGet)("typeSizes.sans.3t.lineHeight"), function (props) {
  return props.disabled ? (0, _helpers.color)("black5") : (0, _helpers.color)("white100");
}, function (_ref2) {
  var disabled = _ref2.disabled,
      error = _ref2.error;
  return (0, _helpers.color)(computeBorderColor({
    disabled: disabled,
    error: error
  }));
}, (0, _helpers.space)(1), function (_ref3) {
  var disabled = _ref3.disabled,
      error = _ref3.error;
  return (0, _helpers.color)(computeBorderColor({
    disabled: disabled,
    error: error,
    pseudo: "hover"
  }));
}, function (_ref4) {
  var disabled = _ref4.disabled,
      error = _ref4.error;
  return (0, _helpers.color)(computeBorderColor({
    disabled: disabled,
    error: error,
    pseudo: "focus"
  }));
});

StyledInput.displayName = "StyledInput";
/**
 * Required
 */

var Required = _styledComponents.default.span.withConfig({
  displayName: "Input__Required",
  componentId: "bysdh7-1"
})(["color:", ";"], (0, _helpers.color)("purple100"));

exports.Required = Required;
Required.displayName = "Required";
//# sourceMappingURL=Input.js.map